import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Error500HandlerService {

  public isError500 = signal<boolean>(false);
}
